import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../../components/navbar";
import bg1 from '../../assets/images/bg/image5-1-2.png';
import bg1Mobile from '../../assets/images/bg/image5-2-4.png';
import bg1Tab from '../../assets/images/bg/image5-3-3.png';
import CtaOne from "../../components/cta/ctaOne";
import Footer from "../../components/footer";
import ScrollTop from "../../components/scrollTop";
import AOS from 'aos';
import 'aos/dist/aos.css';
import doctorClipart from '../../assets/images/doctor.png';
import EnquireModal from "../../components/EnquireModal";

export default function Index() {
    const timelineSectionRef = useRef(null);
    const [showDoctorImages, setShowDoctorImages] = useState(false);
    const [showEnquire, setShowEnquire] = useState(false);

    // Responsive background image selection
    const [headerBg, setHeaderBg] = useState(bg1);

    useEffect(() => {
        function handleScroll() {
            if (!timelineSectionRef.current) return;
            const rect = timelineSectionRef.current.getBoundingClientRect();
            // Show images if section is in viewport (at least 100px visible)
            setShowDoctorImages(
                window.innerWidth >= 1200 && rect.top < window.innerHeight - 450 && rect.bottom > 500
            );


        }
        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleScroll);
        handleScroll();
        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);
        };
    }, []);

    useEffect(() => {
        AOS.init({ duration: 600, once: true, offset: 60 });
    }, []);

    useEffect(() => {
        function updateHeaderBg() {
            const width = window.innerWidth;
            if (width < 665) {
                setHeaderBg(bg1Mobile);
            } else if (width < 1200) {
                setHeaderBg(bg1Tab);
            } else {
                setHeaderBg(bg1);
            }
        }
        updateHeaderBg();
        window.addEventListener('resize', updateHeaderBg);
        return () => window.removeEventListener('resize', updateHeaderBg);
    }, []);

    const teamMembers = [
        // {
        //     name: "Dr. Priya Sharma",
        //     title: "Lead Clinical Geneticist",
        //     img: "https://randomuser.me/api/portraits/women/44.jpg",
        //     desc: "12+ years experience in pediatric and adult genetics. Passionate about patient education and early diagnosis."
        // },
        // {
        //     name: "Dr. Arjun Mehta",
        //     title: "Senior Genetic Counselor",
        //     img: "https://randomuser.me/api/portraits/men/32.jpg",
        //     desc: "Expert in family counseling, rare disorders, and helping patients understand their genetic health."
        // },
        // {
        //     name: "Dr. Neha Kapoor",
        //     title: "Genomics Research Lead",
        //     img: "https://randomuser.me/api/portraits/women/65.jpg",
        //     desc: "Focused on the latest advances in genomics and personalized medicine for Indian families."
        // }
        // Add more team members as needed
    ];

    return (
        <>
            <Navbar manuClass="navigation-menu nav-left" containerClass="container" />
            <EnquireModal show={showEnquire} onClose={() => setShowEnquire(false)} />

            {/* SEO Meta Tags */}
            <Helmet>
                <meta charSet="utf-8" />
                <title>ArogyaVansh - Genetic & Hematology Specialty Clinic</title>
                <link rel="canonical" href="https://arogyavansh.com/" />
                <meta name='description' content="ArogyaVansh - India's Virtual Genetic and Hematology Specialty Clinic. Connect with certified geneticists from home. Affordable, accessible care for every Indian." />
                <meta property="og:title" content="ArogyaVansh - Genetic & Hematology Specialty Clinic" />
                <meta property="og:description" content="India's Virtual Genetic and Hematology Specialty Clinic. Expert consultations from home." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://arogyavansh.com/" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="ArogyaVansh - Genetic & Hematology Specialty Clinic" />
                <meta name="twitter:description" content="India's Virtual Genetic and Hematology Specialty Clinic." />
            </Helmet>

            {/* Header section */}
            <section
                className="bg-half d-table w-100 position-relative"
                style={{ backgroundImage: `url(${headerBg})` }}
            >
                <div className="container">
                    <div className="row mt-5 mt-lg-0">
                        <div className="col-12">
                            <div className="heading-title position-relative">
                                {/* Heading and text: Hide on mobile */}
                                <h4
                                    className="display-4 fw-bold text-black title-dark mt-3 mb-4 d-none d-md-block"
                                    style={{ width: "70%" }}
                                >
                                    Genetic and Hematology Consultation<br /> Made Easy with ArogyaVansh
                                </h4>
                                <p className="para-desc text-black-50 mb-0 d-none d-md-block">
                                    GENETIC & HEMATOLOGY SPECIALTY CLINIC
                                </p>
                                {/* Button: Desktop only */}
                                <div className="mt-4 pt-2 w-100 d-none d-md-flex justify-content-md-start justify-content-center">
                                    <button
                                        className="btn btn-primary w-100 w-md-auto"
                                        type="button"
                                        style={{
                                            maxWidth: 340,
                                            width: "100%",
                                            marginTop: "1.5rem"
                                        }}
                                        onClick={() => setShowEnquire(true)}
                                    >
                                        Enquire Now
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Mobile button absolutely at the bottom of image */}
                <div className="d-block d-md-none w-100" style={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    padding: "0 16px 20px 16px",
                    zIndex: 2
                }}>
                    <button
                        className="btn btn-primary w-100 mobile-enquire-btn"
                        type="button"
                        style={{
                            width: "100%",
                            marginTop: "1.5rem"
                        }}
                        onClick={() => setShowEnquire(true)}
                    >
                        Enquire Now
                    </button>
                </div>
            </section>

            {/* Then and now section */}
            <section className="section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-5 pb-2">
                                {/* <span className="badge rounded-pill bg-soft-primary mb-3">Transformation</span> */}
                                <h4 className="title mb-3">Genetic Healthcare: Then & Now</h4>
                                <h6 className="text-primary fw-normal mb-3">ArogyaVansh is bridging the gap in genetic wellness for all</h6>
                                <p className="text-secondary para-desc mx-auto mb-0">
                                    Discover how ArogyaVansh is revolutionizing access to genetic healthcare for everyone, everywhere.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row align-items-stretch overflow-hidden">
                        <div className="col-lg-5 col-md-6 d-flex" data-aos="fade-right">
                            <div className="card then-now-card shadow border-0 p-4 w-100 d-flex flex-column justify-content-between bg-white" style={{ minHeight: 340 }}>
                                <div className="card shadow border-0 p-4 w-100 d-flex flex-column justify-content-between bg-white" style={{ minHeight: 340 }}>
                                    <h5 className="text-primary mb-3">
                                        <i className="mdi mdi-alert-circle-outline text-primary me-2"></i>
                                        Before: The Struggle for Genetic Healthcare
                                    </h5>
                                    <ul className="list-unstyled text-secondary mb-0 flex-grow-1">
                                        <li className="mb-2"><i className="mdi mdi-clock-outline text-primary me-2"></i>Long wait times for appointments with genetic specialists</li>
                                        <li className="mb-2"><i className="mdi mdi-map-marker-off-outline text-primary me-2"></i>Limited access to genetic experts, especially in rural areas</li>
                                        <li className="mb-2"><i className="mdi mdi-currency-inr text-primary me-2"></i>High costs and travel expenses for in-person consultations</li>
                                        <li className="mb-2"><i className="mdi mdi-help-circle-outline text-primary me-2"></i>Lack of awareness about genetic conditions and their impact</li>
                                        <li><i className="mdi mdi-timer-sand text-primary me-2"></i>Delayed diagnoses leading to prolonged health issues</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 d-none d-lg-flex justify-content-center align-items-center">
                            <div data-aos="zoom-in">
                                <i className="mdi mdi-arrow-right-bold-circle-outline display-4 text-primary"></i>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-6 d-flex mt-4 mt-lg-0" data-aos="fade-left">
                            <div className="card then-now-card shadow border-0 p-4 w-100 d-flex flex-column justify-content-between bg-soft-primary" style={{ minHeight: 340 }}>
                                <div className="card shadow border-0 p-4 w-100 d-flex flex-column justify-content-between bg-soft-primary" style={{ minHeight: 340 }}>
                                    <h5 className="text-primary mb-3">
                                        <i className="mdi mdi-check-circle-outline text-primary me-2"></i>
                                        After: A New Era of Accessible Genetic Care
                                    </h5>
                                    <ul className="list-unstyled text-secondary mb-0 flex-grow-1">
                                        <li className="mb-2"><i className="mdi mdi-flash-outline text-primary me-2"></i>Instant access to expert geneticists from anywhere in India</li>
                                        <li className="mb-2"><i className="mdi mdi-laptop-chromebook text-primary me-2"></i>Affordable and convenient virtual consultations</li>
                                        <li className="mb-2"><i className="mdi mdi-lightbulb-on-outline text-primary me-2"></i>Increased awareness and early detection of genetic conditions</li>
                                        <li className="mb-2"><i className="mdi mdi-calendar-check-outline text-primary me-2"></i>Timely diagnoses and personalized treatment plans</li>
                                        <li><i className="mdi mdi-emoticon-happy-outline text-primary me-2"></i>Improved quality of life for patients and families</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            {/* The Bridge: ArogyaVansh Section */}
            < section className="section bg-soft-primary" >
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-title text-center mb-5 pb-2" data-aos="fade-up">
                                {/* <span className="badge rounded-pill bg-primary mb-3">The Bridge</span> */}
                                <h3 className="title mb-3 text-primary">ArogyaVansh - India's First Virtual Genetic Wellness Platform</h3>
                                <p className="text-secondary para-desc mx-auto mb-0 fs-5">
                                    How ArogyaVansh Transforms Genetic Healthcare
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4">
                        {/* Virtual Consultations */}
                        <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="100">
                            <div className="card h-100 border-0 shadow-sm p-4 text-center">
                                <div className="mb-3">
                                    <i className="mdi mdi-video-outline display-4 text-primary"></i>
                                </div>
                                <h5 className="mb-2">Virtual Consultations</h5>
                                <ul className="list-unstyled text-secondary mb-0">
                                    <li>Connect with certified geneticists from the comfort of your home</li>
                                    <li>No travel required, saving time and money</li>
                                </ul>
                            </div>
                        </div>
                        {/* Pan-India Accessibility */}
                        <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="200">
                            <div className="card h-100 border-0 shadow-sm p-4 text-center">
                                <div className="mb-3">
                                    <i className="mdi mdi-map-marker-radius-outline display-4 text-primary"></i>
                                </div>
                                <h5 className="mb-2">Pan-India Accessibility</h5>
                                <ul className="list-unstyled text-secondary mb-0">
                                    <li>Bringing expert genetic care to every corner of the country</li>
                                    <li>Bridging the urban-rural healthcare divide</li>
                                </ul>
                            </div>
                        </div>
                        {/* User-Friendly Platform */}
                        <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="300">
                            <div className="card h-100 border-0 shadow-sm p-4 text-center">
                                <div className="mb-3">
                                    <i className="mdi mdi-cellphone-cog display-4 text-primary"></i>
                                </div>
                                <h5 className="mb-2">User-Friendly Platform</h5>
                                <ul className="list-unstyled text-secondary mb-0">
                                    <li>Easy appointment booking process</li>
                                    <li>Secure video calls for consultations</li>
                                </ul>
                            </div>
                        </div>
                        {/* Comprehensive Care */}
                        <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="400">
                            <div className="card h-100 border-0 shadow-sm p-4 text-center">
                                <div className="mb-3">
                                    <i className="mdi mdi-account-heart-outline display-4 text-primary"></i>
                                </div>
                                <h5 className="mb-2">Comprehensive Care</h5>
                                <ul className="list-unstyled text-secondary mb-0">
                                    <li>Personalized genetic counseling</li>
                                    <li>Guidance on genetic testing when necessary</li>
                                    <li>Free follow-up consultation included</li>
                                </ul>
                            </div>
                        </div>
                        {/* Education and Awareness */}
                        <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="500">
                            <div className="card h-100 border-0 shadow-sm p-4 text-center">
                                <div className="mb-3">
                                    <i className="mdi mdi-school-outline display-4 text-primary"></i>
                                </div>
                                <h5 className="mb-2">Education and Awareness</h5>
                                <ul className="list-unstyled text-secondary mb-0">
                                    <li>Resources for patients and families to understand genetic conditions</li>
                                    <li>Support for healthcare providers in recognizing genetic red flags</li>
                                </ul>
                            </div>
                        </div>
                        {/* Affordable Pricing */}
                        <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="600">
                            <div className="card h-100 border-0 shadow-sm p-4 text-center">
                                <div className="mb-3">
                                    <i className="mdi mdi-currency-inr display-4 text-primary"></i>
                                </div>
                                <h5 className="mb-2">Affordable Pricing</h5>
                                <ul className="list-unstyled text-secondary mb-0">
                                    <li>Transparent and competitive consultation fees</li>
                                    <li>Making genetic healthcare accessible to more people</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            {/* Step Timeline: Take the First Step Towards Genetic Wellness */}
            < section
                className="section position-relative"
                ref={timelineSectionRef}
                id="timeline-section"
                style={{ overflow: "visible" }
                }
            >
                {/* Doctor Clipart Left & Right (fixed, only when section in view, desktop only) */}
                {
                    showDoctorImages && (
                        <>
                            <img
                                src={doctorClipart}
                                alt="Doctor"
                                loading="lazy"
                                width="auto"
                                height="520"
                                className="timeline-doctor-left"
                                style={{
                                    position: "fixed",
                                    left: -50,
                                    top: "calc(15vh + 40px)",
                                    maxHeight: 520,
                                    width: "auto",
                                    zIndex: 100,
                                    pointerEvents: "none",
                                    transition: "opacity 0.3s"
                                }}
                            />
                            <img
                                src={doctorClipart}
                                alt=""
                                aria-hidden="true"
                                loading="lazy"
                                width="auto"
                                height="520"
                                className="timeline-doctor-right"
                                style={{
                                    position: "fixed",
                                    right: -50,
                                    top: "calc(15vh + 40px)",
                                    maxHeight: 520,
                                    width: "auto",
                                    zIndex: 100,
                                    pointerEvents: "none",
                                    transform: "scaleX(-1)",
                                    transition: "opacity 0.3s"
                                }}
                            />
                        </>
                    )
                }
                <div className="container timeline-content">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-title text-center mb-5 pb-2" data-aos="fade-up">
                                {/* <span className="badge rounded-pill bg-soft-primary mb-3">Get Started</span> */}
                                <h3 className="title mb-3 text-primary">Take the First Step Towards Genetic Wellness</h3>
                                <p className="text-secondary para-desc mx-auto mb-0 fs-5">
                                    Your journey to better health is just a few steps away.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="timeline-steps position-relative mx-auto">
                                {/* Step 1 */}
                                <div className="timeline-step d-flex flex-column align-items-center mb-5" data-aos="fade-up" data-aos-delay="100">
                                    <div className="timeline-icon-center d-flex align-items-center justify-content-center bg-primary text-white rounded-circle mb-3">
                                        <i className="mdi mdi-calendar-plus display-6"></i>
                                    </div>
                                    <div className="timeline-line-center"></div>
                                    <div className="timeline-text-center text-center">
                                        <h5 className="mb-1">Book a consultation on our website</h5>
                                        <p className="text-secondary mb-0">Start your journey by scheduling a session online.</p>
                                    </div>
                                </div>
                                {/* Step 2 */}
                                <div className="timeline-step d-flex flex-column align-items-center mb-5" data-aos="fade-up" data-aos-delay="200">
                                    <div className="timeline-icon-center d-flex align-items-center justify-content-center bg-primary text-white rounded-circle mb-3">
                                        <i className="mdi mdi-clock-outline display-6"></i>
                                    </div>
                                    <div className="timeline-line-center"></div>
                                    <div className="timeline-text-center text-center">
                                        <h5 className="mb-1">Choose a convenient time slot</h5>
                                        <p className="text-secondary mb-0">Pick a time that fits your schedule.</p>
                                    </div>
                                </div>
                                {/* Step 3 */}
                                <div className="timeline-step d-flex flex-column align-items-center mb-5" data-aos="fade-up" data-aos-delay="300">
                                    <div className="timeline-icon-center d-flex align-items-center justify-content-center bg-primary text-white rounded-circle mb-3">
                                        <i className="mdi mdi-video-outline display-6"></i>
                                    </div>
                                    <div className="timeline-line-center"></div>
                                    <div className="timeline-text-center text-center">
                                        <h5 className="mb-1">Meet with a genetic expert via video call</h5>
                                        <p className="text-secondary mb-0">Consult securely from the comfort of your home.</p>
                                    </div>
                                </div>
                                {/* Step 4 */}
                                <div className="timeline-step d-flex flex-column align-items-center mb-5" data-aos="fade-up" data-aos-delay="400">
                                    <div className="timeline-icon-center d-flex align-items-center justify-content-center bg-primary text-white rounded-circle mb-3">
                                        <i className="mdi mdi-account-check-outline display-6"></i>
                                    </div>
                                    <div className="timeline-line-center"></div>
                                    <div className="timeline-text-center text-center">
                                        <h5 className="mb-1">Receive personalized guidance and support</h5>
                                        <p className="text-secondary mb-0">Get expert advice tailored to your needs.</p>
                                    </div>
                                </div>
                                {/* Step 5 */}
                                <div className="timeline-step d-flex flex-column align-items-center" data-aos="fade-up" data-aos-delay="500">
                                    <div className="timeline-icon-center d-flex align-items-center justify-content-center bg-primary text-white rounded-circle mb-3">
                                        <i className="mdi mdi-gift-outline display-6"></i>
                                    </div>
                                    {/* No line after last step */}
                                    <div className="timeline-text-center text-center">
                                        <h5 className="mb-1">Enjoy a free follow-up consultation</h5>
                                        <p className="text-secondary mb-0">Continue your wellness journey with ongoing support.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            {/* <br />
            <br /> */}
            <CtaOne />

            {/* How ArogyaVansh Transforms Genetic Healthcare - Patient Journey */}
            <section className="section bg-soft-primary">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-title text-center mb-5 pb-2" data-aos="fade-up">
                                {/* <span className="badge rounded-pill bg-primary mb-3">Your Journey with Us</span> */}
                                <h3 className="title mb-3 text-primary">How ArogyaVansh Supports You</h3>
                                <p className="text-secondary para-desc mx-auto mb-0 fs-5">
                                    We make genetic healthcare simple, supportive, and accessible—every step of the way.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center align-items-md-center gap-4 patient-journey-steps">
                                {/* Step 1 */}
                                <div className="text-center flex-fill" data-aos="fade-up" data-aos-delay="100">
                                    <div className="rounded-circle bg-white shadow d-inline-flex align-items-center justify-content-center mb-3" style={{ width: 70, height: 70 }}>
                                        <i className="mdi mdi-calendar-plus display-5 text-primary"></i>
                                    </div>
                                    <h6 className="fw-bold text-primary mb-1">Book Easily</h6>
                                    <div className="text-secondary small">Schedule your appointment online in minutes.</div>
                                </div>
                                {/* Arrow */}
                                <div className="d-none d-md-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 40 }}>
                                    <i className="mdi mdi-arrow-right-thick display-6 text-primary"></i>
                                </div>
                                {/* Step 2 */}
                                <div className="text-center flex-fill" data-aos="fade-up" data-aos-delay="200">
                                    <div className="rounded-circle bg-white shadow d-inline-flex align-items-center justify-content-center mb-3" style={{ width: 70, height: 70 }}>
                                        <i className="mdi mdi-video-outline display-5 text-primary"></i>
                                    </div>
                                    <h6 className="fw-bold text-primary mb-1">Meet Virtually</h6>
                                    <div className="text-secondary small">Connect with a friendly genetic expert from home.</div>
                                </div>
                                {/* Arrow */}
                                <div className="d-none d-md-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 40 }}>
                                    <i className="mdi mdi-arrow-right-thick display-6 text-primary"></i>
                                </div>
                                {/* Step 3 */}
                                <div className="text-center flex-fill" data-aos="fade-up" data-aos-delay="300">
                                    <div className="rounded-circle bg-white shadow d-inline-flex align-items-center justify-content-center mb-3" style={{ width: 70, height: 70 }}>
                                        <i className="mdi mdi-account-heart-outline display-5 text-primary"></i>
                                    </div>
                                    <h6 className="fw-bold text-primary mb-1">Personal Guidance</h6>
                                    <div className="text-secondary small">Get answers, support, and a clear care plan.</div>
                                </div>
                                {/* Arrow */}
                                <div className="d-none d-md-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 40 }}>
                                    <i className="mdi mdi-arrow-right-thick display-6 text-primary"></i>
                                </div>
                                {/* Step 4 */}
                                <div className="text-center flex-fill" data-aos="fade-up" data-aos-delay="400">
                                    <div className="rounded-circle bg-white shadow d-inline-flex align-items-center justify-content-center mb-3" style={{ width: 70, height: 70 }}>
                                        <i className="mdi mdi-gift-outline display-5 text-primary"></i>
                                    </div>
                                    <h6 className="fw-bold text-primary mb-1">Ongoing Care</h6>
                                    <div className="text-secondary small">Enjoy free follow-up and resources for your family.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Team of Experts Section */}
            <section className="section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-title text-center mb-5 pb-2" data-aos="fade-up">
                                {/* <span className="badge rounded-pill bg-soft-primary mb-3">Meet Our Experts</span> */}
                                <h3 className="title mb-3 text-primary">ArogyaVansh Expert Team</h3>
                                <p className="text-secondary para-desc mx-auto mb-0 fs-5">
                                    Our team of certified geneticists and counselors is dedicated to guiding you and your family with compassion, experience, and the latest in genetic science.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4 justify-content-center">
                        {teamMembers.map((member, idx) => (
                            <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay={100 * (idx + 1)} key={member.name}>
                                <div className="card border-0 shadow-sm p-4 text-center h-100">
                                    <img
                                        src={member.img}
                                        alt={member.name}
                                        className="rounded-circle mx-auto mb-3"
                                        style={{ width: 90, height: 90, objectFit: 'cover', border: '4px solid #e3f0fa' }}
                                    />
                                    <h5 className="mb-1 text-primary">{member.name}</h5>
                                    <div className="text-secondary mb-2 small">{member.title}</div>
                                    <div className="text-secondary small">{member.desc}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="row justify-content-center mt-4">
                        <div className="col-auto">
                            <div className="text-secondary small text-center">
                                ...and many more caring professionals, all here for you!
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Testimonials */}
            {/* <section className="section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title mb-4">Patients Says</h4>
                                <p className="text-secondary mx-auto para-desc mb-0">Great doctor if you need your family member to get effective immediate assistance, emergency treatment or a simple consultation.</p>
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-8 mt-4 pt-2 text-center">
                            <Patients />
                        </div>
                    </div>
                </div>
            </section> */}

            <Footer />
            <ScrollTop />
        </>
    )
}